import axios from 'axios'

export const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

http.interceptors.request.use(
  config => {

    let user = JSON.parse(localStorage.getItem('currentUser'))

    if (user) {
      config.headers['Authorization'] = `Bearer ${user.auth_token[0]}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
